var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.384,
    height: 15.384,
    viewBox: "0 0 15.384 15.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    "data-name": "Icon metro-cross",
    d: "M17.814,14.287h0L13.147,9.62l4.667-4.667h0a.482.482,0,0,0,0-.68l-2.2-2.2a.482.482,0,0,0-.68,0h0L10.263,6.735,5.6,2.069h0a.482.482,0,0,0-.68,0l-2.2,2.2a.482.482,0,0,0,0,.68h0L7.378,9.62,2.711,14.287h0a.482.482,0,0,0,0,.68l2.2,2.2a.482.482,0,0,0,.68,0h0L10.263,12.5l4.667,4.667h0a.482.482,0,0,0,.68,0l2.2-2.2a.482.482,0,0,0,0-.68Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.115f57a24bd5abfa92cc08966e57c6f1.svg";
export { ForwardRef as ReactComponent };